(function () {
  document.querySelectorAll('[data-four-boxes]').forEach(function (section) {

    var track   = section.querySelector('.four-boxes-section__track');
    var slides  = Array.from(section.querySelectorAll('.four-boxes-section__box'));
    var btnPrev = section.querySelector('.four-boxes-section__arrow--prev');
    var btnNext = section.querySelector('.four-boxes-section__arrow--next');
    var fill    = section.querySelector('.four-boxes-section__progress-fill');

    if (!track || slides.length === 0) return;

    var currentIndex = 0;

    /* ── Visible count per breakpoint ── */
    function getVisible() {
      var w = window.innerWidth;
      if (w <= 768)  return 1;
      if (w <= 1024) return 2;
      return 4;
    }

    function getMaxIndex() {
      return Math.max(0, slides.length - getVisible());
    }

    /* ── Show/hide controls ── */
    function updateVisibility() {
      if (getMaxIndex() > 0) {
        section.classList.add('four-boxes--active');
      } else {
        section.classList.remove('four-boxes--active');
      }
    }

    /* ── Move to index ── */
    function goTo(index) {
      var max = getMaxIndex();
      currentIndex = Math.max(0, Math.min(index, max));

      var slideWidth = slides[0].getBoundingClientRect().width;
      var gap = window.innerWidth > 768 ? 16 : 0;
      track.style.transform = 'translateX(-' + ((slideWidth + gap) * currentIndex) + 'px)';

      var pct = max === 0 ? 100 : Math.round((currentIndex / max) * 100);
      fill.style.width = pct + '%';

      btnPrev.disabled = currentIndex === 0;
      btnNext.disabled = currentIndex >= max;
    }

    btnPrev.onclick = function () { goTo(currentIndex - 1); };
    btnNext.onclick = function () { goTo(currentIndex + 1); };

    /* ── Debounced resize ── */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, getMaxIndex());
        updateVisibility();
        goTo(currentIndex);
      }, 150);
    });

    /* ── Touch swipe ── */
    var touchStartX = null;

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }
      touchStartX = null;
    }, { passive: true });

    /* ── Video play/pause toggle ── */
    // section.querySelectorAll('[data-play-btn]').forEach(function (btn) {
    //   var video    = btn.closest('.four-boxes-section__bg').querySelector('[data-box-video]');
    //   var playIcon  = btn.querySelector('[data-play-icon]');
    //   var pauseIcon = btn.querySelector('[data-pause-icon]');

    //   if (!video) return;

    //   /* Autoplay on load */
    //   video.play().catch(function () {});
    //   playIcon.style.display  = 'none';
    //   pauseIcon.style.display = '';

    //   btn.addEventListener('click', function () {
    //     if (video.paused) {
    //       video.play();
    //       playIcon.style.display  = 'none';
    //       pauseIcon.style.display = '';
    //     } else {
    //       video.pause();
    //       playIcon.style.display  = '';
    //       pauseIcon.style.display = 'none';
    //     }
    //   });
    // });

    section.querySelectorAll('[data-box-video]').forEach(function (v) {
        v.play().catch(function () {});
    });

    /* ── Init ── */
    updateVisibility();
    goTo(0);
  });
})();